import { palette } from "../../theme/palette";
import { View } from "../View";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    fontSize: "13px",
  },
  left: {
    flex: 3,
    display: "flex",
    flexDirection: "column",
    textAlign: "right",
    fontWeight: "bold",
    color: palette.typography.white.high,
  },
  right: {
    flex: 1,
    display: "flex",
    marginLeft: "10px",
    fontWeight: "400",
    alignItems: "right",
    color: palette.typography.white.medium,
  },
}));

const KeyValue = ({ property, value, leftSize = 3, rightSize = 1 }) => {
  const styles = useStyles();
  return (
    <View className={styles.container}>
      <View className={styles.left} style={{ flex: leftSize }}>
        {property}
      </View>
      <View className={styles.right} style={{ flex: rightSize }}>
        {value}
      </View>
    </View>
  );
};

export default KeyValue;
